export type Theme = 'light' | 'dark'

export function applyDocumentTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

/** Guest routes (landing, login) always use light theme — ignore user preferences. */
export function applyPublicLightTheme() {
  document.documentElement.classList.remove('dark')
}
